import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { RepositoryService } from '@shared/services/repository';
import { HttpRepo } from '@shared/services/httprepo';
import { AuthService } from '@services/auth.service';
import { ApiEndPointType } from '@shared/enums/common';
import { DataSourceRequestState } from '@progress/kendo-data-query';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

    constructor(
        private httpRepo: HttpRepo, private authConfig: AuthService,
        private repo: RepositoryService) {
        this.httpRepo.setAbsoluteUrl(this.authConfig.getCompanyId(), ApiEndPointType.FS);
    }

    public GetRequest() {
        this.repo.getData('api/copmany/createCustomer').subscribe(response => {
            // result here
        },
            (error) => {
                // if errors
            }
        )
    }

    CreateCustomer(data: any) {
        data.ID = '00000000-0000-0000-0000-000000000000';
        return this.httpRepo.Post("customers", data);
    }
    CreateorUpdateJobSite(customerID: string, data: any, isUpdate: boolean = false) {
        if (isUpdate == false) {
            if (data.Contacts != null && data.Contacts.length > 0)
                data.Contacts[0].ID = "00000000-0000-0000-0000-000000000000";
            return this.httpRepo.Post("customers/" + customerID + "/jobsites", data);
        }
        else

            return this.httpRepo.Put("customers/" + customerID + "/jobsites/" + data.ID, data);
    }
    CreateUpdateDeleteJobSiteAttachment(customerID: string, jobSiteId: string, data: any, type: number) { // 0 nnew, 1 edit, 2 delete
        if (type == 0) {
            return this.httpRepo.Post("customers/" + customerID + "/jobsites/" + jobSiteId + "/attachments", data);
        }
        else if (type == 1) {
            return this.httpRepo.Put("customers/" + customerID + "/jobsites/" + jobSiteId + "/attachments/" + data[0].ID, data[0]);
        }
        else if (type == 2) {
            return this.httpRepo.Delete("customers/" + customerID + "/jobsites/" + jobSiteId + "/attachments/" + data[0].ID);
        }
    }
    GetJobSiteDetail(CustomerID: string, JobsiteID: string, references: string) {
        return this.httpRepo.Get("customers/" + CustomerID + "/jobsites/" + JobsiteID + "?references=" + references);
    }

    GetJobSiteWorkOrders(JobSiteID: string, state: DataSourceRequestState, searchKey: string) {
        return this.httpRepo.Get("worktickets/jobsites/" + JobSiteID, this.httpRepo.GetCommonURLQueryParams(state, searchKey) + "&searchEntity=jobsiteworkticket");
    }

    GetJobSiteAttachments(CustomerID: string,JobSiteID: string, state: DataSourceRequestState, searchKey: string) {
        return this.httpRepo.Get("customers/" + CustomerID + "/jobsites/" + JobSiteID + "/attachments", this.httpRepo.GetCommonURLQueryParams(state, searchKey));
    }

    GetBillingDetail(CustomerID: string, references: string) {
        return this.httpRepo.Get("customers/" + CustomerID + "?references=" + references);
    }
    GetPinnedNotes(data: any) {
        let Notes = null;//this.dummyData.dummyNotes();
        return of(Notes)
    }
    getZipCodeData(zipcode: string, references: string) {
        return this.httpRepo.Get("zipcodes/" + zipcode + "?references=" + references);
    }
    getIntialData(references: string) {
        return this.httpRepo.GetReferences("?references=" + references);
    }
    getListOfCustomers(searchType: string, state: DataSourceRequestState, searchKey: string) {
        if (searchType == "JobSite") {
            return this.httpRepo.Get("jobsites/search", this.httpRepo.GetCommonURLQueryParams(state, searchKey));
        }
        else {
            return this.httpRepo.Get("customers/search", this.httpRepo.GetCommonURLQueryParams(state, searchKey));
        }
    }
    GetCustomerLanding(searchType: string, state: any, searchKey: string) {
        return this.httpRepo.Get("jobsites/jobsitelanding", this.httpRepo.GetCommonURLQueryParams(state, searchKey) + "&searchEntity=" + searchType.toLowerCase());
    }
    GetCustomerJobSites(CustomerID: string, references: string) {
        return this.httpRepo.Get("customers/" + CustomerID + "/jobsites");
    }
    GetAttachmentURL(CustomerID: string, JobSiteID) {
        return this.httpRepo.AbsoluteURL + "/customers/" + CustomerID + "/jobsites/" + JobSiteID + "/jobsiteattachment";
    }
}
